// 🩺 System Health (owner 2026-10-29/30) — the hourly checks of controllers/health-watch.js, shown in the app instead of
// Telegram: logins, syncs, Auto-Pilot, Marjane floor prices, paused strategies, stock deductions. Admin only.
import { FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import ContextStore from '../hooks/ContextStore';
import { urls } from '../dispatch/urls';

interface Check { key: string; label: string; ok: boolean; detail: string; since: string | null; checkedAt: string | null }
const t = (s: string | null) => (s ? new Date(s).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');

const SystemHealthPage: FC = () => {
  const { contextStore } = useContext(ContextStore);
  const api = useMemo(() => axios.create({ baseURL: `${urls.baseUrlRestApi}/health-watch`, headers: { 'x-auth-token': contextStore?.token || '' }, timeout: 600000 }), [contextStore?.token]);
  const [rows, setRows] = useState<Check[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => { try { setRows((await api.get('/')).data); setErr(null); } catch (e: any) { setErr(e?.response?.data?.error?.message || e.message); } }, [api]);
  useEffect(() => { load(); }, [load]);
  const runNow = async () => { setBusy(true); try { setRows((await api.post('/run')).data); window.dispatchEvent(new Event('health-changed')); } catch (e: any) { setErr(e?.response?.data?.error?.message || e.message); } setBusy(false); };
  const bad = (rows || []).filter((r) => !r.ok);
  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 12 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 800, margin: 0 }}>🩺 System Health</h1>
          <p style={{ fontSize: 12.5, color: '#64748b', margin: '2px 0 0' }}>Checked every hour at :40. A broken check shows here, as a red bar at the top of the app and on the sidebar.</p>
        </div>
        <button onClick={runNow} disabled={busy} style={{ border: 'none', borderRadius: 8, background: '#0f172a', color: '#fff', fontWeight: 700, padding: '8px 12px', cursor: 'pointer' }}>{busy ? 'Checking… (≈1 min)' : '↻ Check now'}</button>
      </div>
      {err && <div style={{ color: '#b91c1c', marginBottom: 8 }}>⚠️ {err}</div>}
      {rows && (bad.length
        ? <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#991b1b', borderRadius: 12, padding: 10, fontWeight: 800, marginBottom: 12 }}>{bad.length} problem{bad.length > 1 ? 's' : ''} need attention</div>
        : <div style={{ background: '#ecfdf5', border: '1px solid #6ee7b7', color: '#047857', borderRadius: 12, padding: 10, fontWeight: 800, marginBottom: 12 }}>✅ Everything is working</div>)}
      {(rows || []).sort((a, b) => Number(a.ok) - Number(b.ok)).map((r) => (
        <div key={r.key} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', background: '#fff', border: `1px solid ${r.ok ? '#e2e8f0' : '#fca5a5'}`, borderRadius: 12, padding: 10, marginBottom: 8 }}>
          <div style={{ fontSize: 20 }}>{r.ok ? '✅' : '❌'}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 800, fontSize: 14 }}>{r.label}</div>
            <div style={{ fontSize: 13, color: r.ok ? '#475569' : '#b91c1c' }}>{r.detail}</div>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>{r.ok ? 'OK' : 'Broken'} since {t(r.since)} · last check {t(r.checkedAt)}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default SystemHealthPage;
